import { MouseEventHandler, ReactNode } from "react";
import { Paper, TooltipProps } from "@mantine/core";
import {
  LeafletControlWrapper,
  LeafletControlWrapperProps,
} from "components/LeafletMap/Utils/LeafletControlWrapper";
import { Tooltip } from "components/UI/Tooltip";
import {
  CONTROL_BUTTON_SETTINGS,
  CONTROL_BUTTON_SHADOW,
} from "config/constants";

import { ControlActionIcon } from "../MapControls/ControlActionIcon";

type Props = {
  position: LeafletControlWrapperProps["position"];
  icon: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  tooltip?: {
    label: string;
    position: TooltipProps["position"];
  };
};

export const LeafletSingleIconControlWrapper = ({
  position,
  icon,
  onClick,
  tooltip,
}: Props) => (
  <LeafletControlWrapper position={position}>
    <Paper
      style={{
        boxShadow: CONTROL_BUTTON_SHADOW,
        fontSize: CONTROL_BUTTON_SETTINGS.iconFontSize,
      }}
      shadow="xs"
    >
      {tooltip ? (
        <Tooltip label={tooltip.label} position={tooltip.position}>
          <ControlActionIcon onClick={onClick}>{icon}</ControlActionIcon>
        </Tooltip>
      ) : (
        <ControlActionIcon onClick={onClick}>{icon}</ControlActionIcon>
      )}
    </Paper>
  </LeafletControlWrapper>
);

LeafletSingleIconControlWrapper.displayName = "LeafletSingleIconControlWrapper";
